import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Plan, PlanMeta } from "@readyfit-common/models";
import { getWeeksForPlan } from "@readyfit-common/utils";
import TrainingScheduleWeek from "../ChatTrainingScheduleWeek/ChatTrainingScheduleWeek";
import useStyles from "./ChatTrainingSchedule.style";

interface ChatTrainingScheduleProps {
  trainingPlan: Plan;
  meta: PlanMeta;
  receiverId: string;
}

export default function ChatTrainingSchedule({
  trainingPlan,
  meta,
  receiverId,
}: ChatTrainingScheduleProps) {
  const classes = useStyles();
  const [currentWeek, setCurrentWeek] = useState(
    meta?.weeks?.current === 0 ? 1 : meta?.weeks?.current,
  );
  const totalWeeks = meta?.weeks?.total;
  const weeks = getWeeksForPlan(trainingPlan);
  const currentWeekData = weeks[currentWeek - 1];

  return (
    <Grid container flexDirection={"column"} gap={2} flex={1}>
      {/* Calendar Header */}
      <Typography variant="h6" fontWeight={600}>
        {new Date().toLocaleString("en-US", {
          month: "long",
          day: "numeric",
        })}
      </Typography>
      <Grid container alignItems={"center"}>
        {currentWeek > 1 && (
          <IconButton onClick={() => setCurrentWeek(currentWeek - 1)}>
            <ChevronLeft />
          </IconButton>
        )}
        <Typography variant="caption" fontWeight={400}>
          Week {currentWeek} of {totalWeeks}
        </Typography>
        {currentWeek < totalWeeks && (
          <IconButton onClick={() => setCurrentWeek(currentWeek + 1)}>
            <ChevronRight />
          </IconButton>
        )}
      </Grid>
      <Button
        variant="text"
        className={classes.viewTrianingPlanButton}
        component={Link}
        to={`/grading/athletes/${receiverId}`}
      >
        View training plan
      </Button>
      {/* Training Schedule */}
      {currentWeekData && <TrainingScheduleWeek planWeek={currentWeekData} />}
    </Grid>
  );
}
